import { Theme } from '@aws-amplify/ui-react';
import { alpha } from '@mui/material';
import { spaceCadet, ultraMarine } from '../utils/colors';

const theme: Theme = {
  name: 'cogneed-theme',
  tokens: {
    fonts: {
      default: {
        variable: {
          value: "'Source Sans Pro', 'Open Sans', sans-serif, Roboto",
        },
        static: {
          value: "'Source Sans Pro', 'Open Sans', sans-serif, Roboto",
        },
      },
    },
    components: {
      tabs: {
        item: {
          color: { value: '{colors.brand.secondary.60.value}' },
          _hover: {
            color: { value: '{colors.brand.primary.60.value}' },
          },
        },
      },
      authenticator: {
        container: {
          widthMax: {
            value: '100%',
          },
        },
        router: {
          borderWidth: { value: '0px' },
        },
      },
      button: {
        primary: {
          backgroundColor: { value: '{colors.brand.primary.60.value}' },
          _hover: { backgroundColor: { value: '{colors.brand.primary.80.value}' } },
          _focus: { backgroundColor: { value: '{colors.brand.primary.80.value}' } },
        },
        link: {
          color: { value: '{colors.brand.primary.60.value}' },
          _hover: {
            color: { value: '{colors.brand.primary.80.value}' },
            backgroundColor: { value: '{colors.brand.primary.20.value}' },
          },
        },
      },
    },
    colors: {
      brand: {
        secondary: {
          10: { value: alpha(spaceCadet[100], 0.5) },
          20: { value: spaceCadet[100] },
          40: { value: spaceCadet[400] },
          60: { value: spaceCadet[500] },
          80: { value: spaceCadet[600] },
          100: { value: spaceCadet[700] },
        },
        primary: {
          10: { value: alpha(ultraMarine[100], 0.5) },
          20: { value: ultraMarine[100] },
          40: { value: ultraMarine[400] },
          60: { value: ultraMarine[500] },
          80: { value: ultraMarine[600] },
          100: { value: ultraMarine[700] },
        },
      },
    },
  },
};
export default theme;
